/**
 * 注册路由
 * 2017-12-6
 */
"use strict";
angular.module("successEnterpriseRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("register.successenterprise",{
        url:"/successenterprise",
        views:{
            "main@register": {
                templateUrl: "./login/register/pgcSuccessEnterprise/pgcSuccessEnterprise_tpl.html",
                controller: "successEnterpriseCtrl"
            }
        }
    });
}]);